import * as types from 'actions/actionTypes';
import initialState from '../initialState';

/**
 * reducer per gestire le interrogazioni a crashboxx - download lista pdf
 * @param {*} state
 * @param {*} action
 */
export default function crashboxxDownloadAllListPdfReducer(state = initialState.crashboxxFiles.allListPdf, action){

    switch(action.type)
    {
        case types.DOWNLOAD_ALLLISTPDF_REQUEST:
            return {...state, error: null, isLoading: true};
        case types.DOWNLOAD_ALLLISTPDF_SUCCESS:
            return {...state, error: null, isLoading: false};
        case types.DOWNLOAD_ALLLISTPDF_ERROR:
            return {...state, error: action.error, isLoading: false};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/crashboxx/crashboxxDownloadAllListPdfReducer.js